import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { andoPageMeta, andoSchema } from 'components/common/schema'
import Template from 'components/cases/ando'

const Ando: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...andoPageMeta} />
      <JsonLd data={andoSchema} />
      <Template />
    </>
  )
}

export default Ando
